import { IconSwords, IconShield, IconHome, IconUsers, IconChevronDown, IconInfoCircle } from "@tabler/icons-react";
import "./colony-strength.css";

export function ColonyStrength({ attack, health, bonus, total, capacity }) {
  return <section className="kh-colony-power" aria-label="Сила колонии">
    <header className="kh-colony-power__header">
      <span className="kh-colony-power__title"><IconSwords size={17} aria-hidden="true" />Сила колонии</span>
      <span className="kh-colony-power__status">Готовность гнезда</span>
    </header>
    <div className="kh-colony-power__stats">
      <div className="kh-colony-power__stat kh-colony-power__stat--attack">
        <span className="kh-colony-power__label"><IconSwords size={17} aria-hidden="true" />Атака</span>
        <strong>{attack.toLocaleString("ru-RU")}</strong>
        <span className="kh-colony-power__caption">Базовый урон за раунд</span>
      </div>
      <div className="kh-colony-power__stat kh-colony-power__stat--defense">
        <span className="kh-colony-power__label"><IconShield size={17} aria-hidden="true" />Защита</span>
        <strong>{Math.floor(health * (1 + bonus / 100)).toLocaleString("ru-RU")}</strong>
        <span className="kh-colony-power__caption">Эффективное здоровье</span>
      </div>
    </div>
    <div className="kh-colony-power__home">
      <span><IconHome size={15} aria-hidden="true" />Домашний бонус</span>
      <b data-active={bonus > 0}>+{bonus}%</b>
    </div>
    <div className="kh-colony-power__population">
      <div><span><IconUsers size={15} aria-hidden="true" />Армия колонии</span><b>{total}<small> / {capacity}</small></b></div>
      <progress value={total} max={capacity} aria-label={`Армия: ${total} из ${capacity}`} />
      <span className="kh-colony-power__caption">Включая гарнизон, раненых и выращиваемых</span>
    </div>
    <details className="kh-colony-power__help">
      <summary><span><IconInfoCircle size={15} aria-hidden="true" />Как считаются показатели</span><IconChevronDown size={16} aria-hidden="true" /></summary>
      <div>
        <p><b>Атака</b> — суммарный базовый урон бойцов в строю. Преимущество типа увеличивает урон на 50%.</p>
        <p><b>Защита</b> — здоровье бойцов в строю с учётом укреплений гнезда. Домашний бонус снижает входящий урон.</p>
        <p>В вылазке учитываются только выбранные бойцы. Уровни действуют до конца события.</p>
      </div>
    </details>
  </section>;
}
